<template>
  <div class="select-wrapper">
    <v-select v-model="value" :items="items" label="期間の選択" />
    <ModalPickerPeriodRange
      v-model="range"
      :show="showPicker"
      @hide="closePicker"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalPickerPeriodRange from './ModalPickerPeriodRange'
import { Periods } from '@/models/StandardReport'

export default {
  name: 'PeriodSelector',
  components: { ModalPickerPeriodRange },
  props: {
    period: {
      type: String,
      required: true,
      validator: value => Object.values(Periods).includes(value),
    },
    calendarRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPicker: false,
      resolvePicker: null,
    }
  },
  computed: {
    value: {
      get() {
        return this.period
      },
      async set(v) {
        if (v === Periods.CALENDAR) {
          // pick range
          await this.openPicker()
          this.resolvePicker = null
        }
        this.updatePeriod(v)
      },
    },
    range: {
      get() {
        return this.calendarRange
      },
      set(v) {
        this.updateCalendarRange(v)
      },
    },
    items() {
      return [
        { text: '今月', value: Periods.CURRENT_MONTH },
        { text: '前月', value: Periods.LAST_MONTH },
        { text: '累計', value: Periods.TOTAL },
        { text: '本日', value: Periods.TODAY },
        { text: '昨日', value: Periods.YESTERDAY },
        { text: '過去7日間', value: Periods.LAST_7_DAYS },
        { text: '過去30日間', value: Periods.LAST_30_DAYS },
        { text: 'カレンダーモード', value: Periods.CALENDAR },
      ]
    },
  },
  methods: {
    ...mapActions('advertiser/standardReport', {
      updatePeriod: 'UPDATE_PERIOD',
      updateCalendarRange: 'UPDATE_CALENDAR_RANGE',
    }),
    selectChanged() {
      this.newRequestFromPeriodSelector({ selectedPeriod: this.selected })
    },
    openPicker() {
      return new Promise(resolve => {
        this.showPicker = true
        this.resolvePicker = resolve
      })
    },
    closePicker() {
      this.resolvePicker()
      this.showPicker = false
    },
  },
}
</script>

<style scoped></style>
